import { Component, OnInit } from "@angular/core";
import { DoctorsService } from "src/app/doctor-section/doctor-service/doctors.service";
import io from "socket.io-client";
import { AppointmentService } from "src/app/appointment-section/appointment-service/appointment.service";
import * as moment from "moment";
import { AdService } from "src/app/ad-section/ad.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { take } from "rxjs/operators";
import * as Chart from 'chart.js';

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  authdata: any;
  appointments: number;
  Doctors: number;
  hospitals: number;
  patients: number;
  patientarr: any;
  moment: any = moment;
  isLoading: any = false;
  isLoadingForSms: any = false;
  todatUpdate: any;
  addLedForm: FormGroup;
  token: String;
  addledData: any;
  addLedSuccessFlag = false;

  distChart: any;
  barChart: any;

  constructor(private authService: AuthService, private docService: DoctorsService, private Appservice: AppointmentService, private adminService: AdService) {}

  ngOnInit() {
    this.authService.authDataSubject.pipe(take(1)).subscribe((res) => {
      this.token = res._token;
    });
    if (localStorage.getItem('authData')) {
      this.authdata = JSON.parse(localStorage.getItem('authData'));
      this.getTodayData(this.authdata.token);
    }
    this.getcount();
    this.addLedForm = new FormGroup({
      pass: new FormControl("air69056", Validators.required),
      ssid: new FormControl("Airtel_same_5936", Validators.required)
    });
  }

  getcount() {
    this.Appservice.count(this.authdata.token).subscribe((res: any) => {
      this.appointments = res.data.appointments;
      this.Doctors = res.data.doctors;
      this.hospitals = res.data.hospitals;
      this.patients = res.data.patients;
      this.renderCharts();
    });
  }

  renderCharts() {
    const ctxD = document.getElementById('distChart') as HTMLCanvasElement;
    if (ctxD) {
      if (this.distChart) this.distChart.destroy();
      this.distChart = new Chart(ctxD, {
        type: 'doughnut',
        data: {
          labels: ['Doctors', 'Hospitals'],
          datasets: [{ data: [this.Doctors, this.hospitals], backgroundColor: ['#4e73df', '#e74a3b'] }]
        },
        options: { maintainAspectRatio: false, cutoutPercentage: 80, legend: { display: false } }
      });
    }
  }

  getTodayData(token) {
    this.adminService.todayUpdate(token).subscribe((res: any) => {
      this.todatUpdate = res.data;
      this.renderBarChart();
    });
  }

  renderBarChart() {
    const ctxB = document.getElementById('docBarChart') as HTMLCanvasElement;
    if (ctxB && this.todatUpdate) {
      if (this.barChart) this.barChart.destroy();
      const labels = this.todatUpdate.map(function(i) { return i.doctorId ? i.doctorId.name : 'N/A'; });
      const data = this.todatUpdate.map(function(i) { return i.count || 0; });
      this.barChart = new Chart(ctxB, {
        type: 'bar',
        data: { labels: labels, datasets: [{ label: 'Appts', backgroundColor: '#4e73df', data: data }] },
        options: { maintainAspectRatio: false, scales: { yAxes: [{ ticks: { beginAtZero: true } }] }, legend: { display: false } }
      });
    }
  }

  getallData() {
    this.isLoading = true;
    this.Appservice.allData(this.authdata.token, 0).subscribe((res: any) => {
      this.patientarr = res.patients.filter(function(o) { return o.appointment; });
      this.isLoading = false;
    }, (err) => { this.isLoading = false; });
  }

  sendOtp(patientId) {
    this.isLoadingForSms = patientId;
    this.adminService.sendSms(patientId, this.authdata.token).subscribe((res) => {
      this.isLoadingForSms = false;
      alert("Success");
    }, (err) => { this.isLoadingForSms = false; });
  }

  onAddLed() {
    this.docService.addLed(this.addLedForm.value, this.token).subscribe((res: any) => {
      this.addLedSuccessFlag = true;
      this.addledData = res.led;
    });
  }
}